import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  isPlatform,
  useIonViewWillEnter,
  useIonViewWillLeave,
} from "@ionic/react";
import { useDispatch } from "react-redux";
import {
  clearCreateFilters,
  setCreateStatus,
  setCreateStep,
  setDeselectAll,
  setDocumentCreateData,
} from "../../store/massiveDocumentCreate";
import { findLocations } from "../../store/massiveDocumentCreate/actions/findLocations";
import { findUserRoles } from "../../store/massiveDocumentCreate/actions/findUserRoles";
import { findSingleUserRole } from "../../store/massiveDocumentCreate/actions/findSingleUserRole";
import { findOrganizations } from "../../store/organizations/actions/findOrganizations";
import { findTemplatesMassiveDocumments } from "../../store/massiveDocumentCreate/actions/findTemplates";
import DocumentCreateForm from "./components/DocumentCreateForm";
import { useParams } from "react-router-dom";
import { findLegalReps } from "../../store/massiveDocumentCreate/actions/findLegalRep";
import { getSignatureProviders } from "../../store/signatureProviders/actions/getSignatureProviders";

export const MassiveDocumentCreate: React.FC = () => {
  console.log("DocumentCreate Render");

  const { userId }: { userId: string } = useParams();

  const dispatch = useDispatch();

  useIonViewWillEnter(() => {
    dispatch(setCreateStep(1));
    dispatch(setDocumentCreateData({}));
    dispatch(setDeselectAll());
    dispatch(clearCreateFilters());
    dispatch(findTemplatesMassiveDocumments());
    dispatch(findLegalReps());
    dispatch(findOrganizations());
    dispatch(findLocations());
    dispatch(setCreateStatus(""));
    dispatch(getSignatureProviders());
    userId != undefined ? dispatch(findSingleUserRole(userId)) : dispatch(findUserRoles());
  });

  useIonViewWillLeave(() => {
    dispatch(setDocumentCreateData({}));
    dispatch(setCreateStep(1));
    dispatch(clearCreateFilters());
    dispatch(setCreateStatus(""));
  });

  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton
              text={isPlatform("ios") ? "Acuerdos" : ""}
              defaultHref={
                userId != undefined
                  ? `/app/supervision/colaborador/${userId}`
                  : "/app/rrhh/acuerdos"
              }
              color="light"
            />
          </IonButtons>
          <IonTitle>
            {userId != undefined
              ? "Creación de acuerdo con plantilla"
              : `Creación masiva de acuerdos`}
          </IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <DocumentCreateForm />
      </IonContent>
    </IonPage>
  );
};
